<template>
  <div class="filtersHeader">
    <!-- TODO: remove div + :firstChild css -->
    <div>
      <button
        aria-label="chevron-left"
        class="abBtn"
        @click="filtersStore.isFilterOpenToggle"
      >
        <span class="icon icon-chevron-left" />
      </button>
    </div>
    <div>
      <div class="hidden md:block">
        <span class="icon icon-filter filtersTitleIcon" /> <span>{{ $l('showresult.viewFilters.filter') }}</span>
      </div>
    </div>
    <div>
      <button
        class="abBtn"
        @click="filtersStore.resetAll"
      >
        <span>{{ $l('showresult.filter.resetTitle') }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useFiltersStore } from './store/filtersStore';

const filtersStore = useFiltersStore();
</script>

<style lang="scss">
.filtersHeader {
  background: $white;
  display: flex;
  flex: 0 0 54px;
  max-height: 54px;
  color: white;
  font-size: 1.8rem;

  button {
    height: 100%;

    & > span:first-child {
      font-size: 1.6rem;
      position: relative;
      top: 0px;
      left: 3px;

      @include breakpoint_up(xxs) {
        font-size: 2rem;
        top: 2px;
        left: 1px;
      }
    }
  }

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;

    &:nth-child(2) {
      flex: 1;
      text-align: center;
      font-size: 1.6rem;

      @include breakpoint_up(xxs) {
        font-size: 1.8rem;
      }

      @include breakpoint_up(md) {
        justify-content: flex-start;
        font-size: 2.2rem;
        font-weight: 600;
        color: $main-font-color;
        margin-left: 1rem;
      }

      @include breakpoint_up(lg) {
        margin-left: unset;
      }
    }

    &:last-child {
      span {
        font-size: 1.6rem;

        @include breakpoint_up(xxs) {
          font-size: 1.8rem;
        }

        @include breakpoint_up(md) {
          font-size: 1.4rem;
        }
      }
    }
  }

  & > div:last-child {
    font-size: 1.5rem;
  }

  @include breakpoint_up(md) {
    padding: 0 0 0 3.5rem;
    background-image: none;
    color: inherit;
    border-bottom: 1px solid $neutral-border-color;

    & > div {
      &:first-child {
        display: none;
      }

      &:last-child {
        font-size: 1.6rem;
        color: $disabled-font-color;
      }
    }
  }

  @include breakpoint_up(lg) {
    padding-left: 2rem;
  }
}
</style>
